import { gql } from '../../../__generated__';

export const GET_CURRENT_USER = gql(/* GraphQL */ `
  query Me {
    me {
      id
      documentId
      username
      email
      confirmed
      blocked
      role {
        id
        name
        description
        type
      }
    }
  }
`);
